/* global axios */
import ApiClient from '../ApiClient';

// V1 Admin Intelligence Bridge (Part 3/4/8) — read-only client for
// Nexceo::Ai::RuntimeInspector#snapshot, exposed via AiRuntimeController.
// No business logic here: read only, no side effects.
class NexceoAiRuntimeAPI extends ApiClient {
  constructor() {
    super('nexceo/leads', { accountScoped: true });
  }

  show(leadId) {
    return axios.get(`${this.url}/${leadId}/ai_runtime`);
  }
}

export default new NexceoAiRuntimeAPI();
